import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { InstallationDetailsStore } from '@store';

@Component({
  selector: 'app-owner-name-panel',
  templateUrl: './owner-name-panel.component.html',
  styleUrls: ['./owner-name-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OwnerNamePanelComponent {
  constructor(
    public installationDetailsStore: InstallationDetailsStore,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  navigateToUserDetailsPage(ownerId: string, ownerName: string): void {
    this.activatedRoute.params.subscribe((param) => {
      const installationId = param['id'];

      const route = this.router.config.find((r) => r.path === 'users/:id');
      route.data = {
        installationId,
        ownerName,
      };

      this.router.navigate([`users/${ownerId}`]);
    });
  }
}
